import styled from "styled-components";
import { pageVar } from "../design-system/tokens/pageColorVars";

interface ResponsiveBoxProps {
  $isChatOpen?: boolean;
  $isHomePath?: boolean;
  $isGlobalPath?: boolean;
  $noPadding?: boolean;
}

const ResponsiveBox = styled.div<ResponsiveBoxProps>`
  //max-width: ${({ $isChatOpen }) =>
    $isChatOpen ? "calc(100% - 40px)" : "75%"};
  width: 100%;
  margin: 0 auto;
  margin-left: ${({ $isChatOpen }) => ($isChatOpen ? "0" : "auto")};
  margin-right: ${({ $isChatOpen }) => ($isChatOpen ? "0" : "auto")};
  border: ${({ $isHomePath }) => ($isHomePath ? "none" : "1px solid darkgray")};
  border-radius: 12px;
  background-color: ${({ $isHomePath }) =>
    $isHomePath ? "transparent" : pageVar("--mb-page-surface")};
  padding: ${({ $noPadding }) => ($noPadding ? "0" : "20px 10px")};
  box-sizing: border-box;
  overflow-y: auto;
  height: calc(100vh - 88px);
  display: flex;
  flex-direction: column;
  position: relative;
  transition: max-width 0.3s ease-in-out, margin-left 0.3s ease-in-out,
    margin-right 0.3s ease-in-out;

  // gradient border only to top
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: ${({ $isGlobalPath, $isHomePath }) =>
      $isGlobalPath || $isHomePath ? "0" : "3px"};
    background-image: linear-gradient(to right, royalblue, skyblue);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  @media (max-width: 820px) {
    margin-left: ${({ $isChatOpen }) => ($isChatOpen ? "20px" : "10px")};
    margin-right: ${({ $isChatOpen }) => ($isChatOpen ? "20px" : "10px")};
  }

  // Hide the visible scrollbar; scrolling still works via mousewheel/trackpad
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

  // Hide scrollbar when not scrolling
  // &:not(:hover)::-webkit-scrollbar-thumb {
  //   background-color: transparent;
  // }

  // &:not(:hover) {
  //   scrollbar-color: transparent transparent;
  // }
`;

export default ResponsiveBox;
